import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { StatusPill, EnvBadge } from "@/components/StatusPill";
import { useI18n } from "@/i18n/I18nContext";
import { Rocket, Loader2, ChevronRight } from "lucide-react";

export default function Missions() {
  const [missions, setMissions] = useState(null);
  const navigate = useNavigate();
  const { t } = useI18n();
  useEffect(() => { api.missions().then(setMissions); }, []);
  if (!missions) return <div className="flex items-center justify-center py-32"><Loader2 className="animate-spin text-[#2563EB]" /></div>;

  return (
    <div className="space-y-6">
      <div>
        <p className="mono-label">{t("missions.label")}</p>
        <h1 className="font-display text-3xl font-extrabold text-white mt-1 flex items-center gap-2"><Rocket className="text-[#2563EB]" /> {t("missions.title")}</h1>
        <p className="text-sm text-[#94A3B8] mt-1">{t("missions.subtitle")}</p>
      </div>
      {missions.length === 0 ? (
        <div className="m-card p-10 text-center text-[#64748B]"><Rocket className="mx-auto mb-3 text-[#334155]" /><p className="text-sm">{t("missions.empty")} <span className="text-white font-mono">Buat content plan LURI SALA 7 hari</span></p></div>
      ) : (
        <div className="space-y-3">
          {missions.map((m) => (
            <div key={m.id} className="m-card m-card-hover p-5 cursor-pointer flex items-center justify-between gap-4" onClick={() => navigate(`/missions/${m.id}`)} data-testid={`mission-card-${m.id}`}>
              <div className="min-w-0">
                <p className="text-white font-semibold">{m.title}</p>
                <p className="text-[11px] text-[#64748B] font-mono mt-1">{m.code} · {m.project_code} · owner {m.owner_agent_code} · ${m.cost}</p>
                <p className="text-xs text-[#94A3B8] mt-1 line-clamp-1">{m.objective}</p>
              </div>
              <div className="flex items-center gap-3 shrink-0"><EnvBadge environment={m.environment} archived={m.archived} /><StatusPill status={m.status} /><ChevronRight size={16} className="text-[#64748B]" /></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
